// extracted by mini-css-extract-plugin
export default {"tabs":"sPQFhLXpHq"};
    if(module.hot) {
      // 1648554217490
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  